module.exports = __webpack_public_path__ + "assets/apo-stab.7b222d03.png";